// Font Awesome
// https://roots.io/guides/how-to-use-font-awesome-5-in-sage/
// Icons should be imported individually to keep bundle size down

// import Font Awesome functionality
import {library, dom} from '@fortawesome/fontawesome-svg-core';

// Note: There is a compiling performance issue with Font Awesome + Webpack 4 + UglifyJS when running yarn build:production
// The easiest solution is the following, import like this:
// import { faInstagram as fabFaInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
// Not like this:
// import { faInstagram as fabFaInstagram } from '@fortawesome/free-brands-svg-icons';

// Free Brands
import {faFacebookF as fabFacebookF} from '@fortawesome/free-brands-svg-icons/faFacebookF';
import {faFacebookSquare as fabFacebookSquare} from '@fortawesome/free-brands-svg-icons/faFacebookSquare';
import {faFacebook as fabFacebook} from '@fortawesome/free-brands-svg-icons/faFacebook';
//
import {faInstagram as fabInstagram} from '@fortawesome/free-brands-svg-icons/faInstagram';
import {faInstagramSquare as fabInstagramSquare} from '@fortawesome/free-brands-svg-icons/faInstagramSquare';
//
import {faLinkedinIn as fabLinkedinIn} from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import {faLinkedin as fabLinkedin} from '@fortawesome/free-brands-svg-icons/faLinkedin';
//
import {faTwitter as fabTwitter} from '@fortawesome/free-brands-svg-icons/faTwitter';
import {faTwitterSquare as fabTwitterSquare} from '@fortawesome/free-brands-svg-icons/faTwitterSquare';
//
import {faYoutube as fabYoutube} from '@fortawesome/free-brands-svg-icons/faYoutube';
import {faYoutubeSquare as fabYouTubeSquare} from '@fortawesome/free-brands-svg-icons/faYoutubeSquare';
// add the imported icons to the library
library.add(
  fabFacebookF,
  fabFacebookSquare,
  fabFacebook,
  //
  fabInstagram,
  fabInstagramSquare,
  //
  fabLinkedinIn,
  fabLinkedin,
  //
  fabTwitter,
  fabTwitterSquare,
  //
  fabYoutube,
  fabYouTubeSquare,
);

// Pro Light
import {faChevronUp as falChevronUp} from '@fortawesome/pro-light-svg-icons/faChevronUp';
import {faChevronDown as falChevronDown} from '@fortawesome/pro-light-svg-icons/faChevronDown';
import {faChevronLeft as falChevronLeft} from '@fortawesome/pro-light-svg-icons/faChevronLeft';
import {faChevronRight as falChevronRight} from '@fortawesome/pro-light-svg-icons/faChevronRight';
//
import {faArrowUpLong as falArrowUpLong} from '@fortawesome/pro-light-svg-icons/faArrowUpLong';
import {faArrowDownLong as falArrowDownLong} from '@fortawesome/pro-light-svg-icons/faArrowDownLong';
import {faArrowLeftLong as falArrowLeftLong} from '@fortawesome/pro-light-svg-icons/faArrowLeftLong';
import {faArrowRightLong as falArrowRightLong} from '@fortawesome/pro-light-svg-icons/faArrowRightLong';
import {faArrowToBottom as falArrowToBottom} from '@fortawesome/pro-light-svg-icons/faArrowToBottom';
import {faArrowUpRight as falArrowUpRight} from '@fortawesome/pro-light-svg-icons/faArrowUpRight';
// 
import {faArrowUp as falArrowUp} from '@fortawesome/pro-light-svg-icons/faArrowUp';
import {faArrowDown as falArrowDown} from '@fortawesome/pro-light-svg-icons/faArrowDown';
import {faArrowLeft as falArrowLeft} from '@fortawesome/pro-light-svg-icons/faArrowLeft';
import {faArrowRight as falArrowRight} from '@fortawesome/pro-light-svg-icons/faArrowRight';
//
import {faArrowCircleUp as falArrowCircleUp} from '@fortawesome/pro-light-svg-icons/faArrowCircleUp';
import {faArrowCircleDown as falArrowCircleDown} from '@fortawesome/pro-light-svg-icons/faArrowCircleDown';
import {faArrowCircleLeft as falArrowCircleLeft} from '@fortawesome/pro-light-svg-icons/faArrowCircleLeft';
import {faArrowCircleRight as falArrowCircleRight} from '@fortawesome/pro-light-svg-icons/faArrowCircleRight';
//
import {faCheck as falCheck} from '@fortawesome/pro-light-svg-icons/faCheck';
import {faTimes as falTimes} from '@fortawesome/pro-light-svg-icons/faTimes';
import {faSearch as falSearch} from '@fortawesome/pro-light-svg-icons/faSearch';
import {faPhone as falPhone} from '@fortawesome/pro-light-svg-icons/faPhone';
import {faEnvelope as falEnvelope} from '@fortawesome/pro-light-svg-icons/faEnvelope';
import {faAt as falAt} from '@fortawesome/pro-light-svg-icons/faAt';
import {faCircle as falCircle} from '@fortawesome/pro-light-svg-icons/faCircle';
import {faSquare as falSquare} from '@fortawesome/pro-light-svg-icons/faSquare';
import {faLocationDot as falLocationDot} from '@fortawesome/pro-light-svg-icons/faLocationDot';
import {faGlobe as falGlobe} from '@fortawesome/pro-light-svg-icons/faGlobe';
import {faStar as falStar} from '@fortawesome/pro-light-svg-icons/faStar';
import {faHeart as falHeart} from '@fortawesome/pro-light-svg-icons/faHeart';
import {faLink as falLink} from '@fortawesome/pro-light-svg-icons/faLink';
import {faShare as falShare} from '@fortawesome/pro-light-svg-icons/faShare';
import {faShareAlt as falShareAlt} from '@fortawesome/pro-light-svg-icons/faShareAlt';
//
import {faFax as falFax} from '@fortawesome/pro-light-svg-icons/faFax';
import {faLanguage as falLanguage} from '@fortawesome/pro-light-svg-icons/faLanguage';
import {faFileDownload as falFileDownload} from '@fortawesome/pro-light-svg-icons/faFileDownload';
import {faFilePdf as falFilePdf} from '@fortawesome/pro-light-svg-icons/faFilePdf';
import {faFileWord as falFileWord} from '@fortawesome/pro-light-svg-icons/faFileWord';
import {faFileExcel as falFileExcel} from '@fortawesome/pro-light-svg-icons/faFileExcel';
import {faSignIn as falSignIn} from '@fortawesome/pro-light-svg-icons/faSignIn';
import {faCalendarAlt as falCalendarAlt} from '@fortawesome/pro-light-svg-icons/faCalendarAlt';
import {faFolder as falFolder} from '@fortawesome/pro-light-svg-icons/faFolder';
import {faTape as falTape} from '@fortawesome/pro-light-svg-icons/faTape';
import {faVirusSlash as falVirusSlash} from '@fortawesome/pro-light-svg-icons/faVirusSlash';
import {faFileSlash as falFileSlash} from '@fortawesome/pro-light-svg-icons/faFileSlash';
import {faGaugeMax as falGaugeMax} from '@fortawesome/pro-light-svg-icons/faGaugeMax';
import {faDiagramProject as falDiagramProject} from '@fortawesome/pro-light-svg-icons/faDiagramProject';
import {faFaceSmile as falFaceSmile} from '@fortawesome/pro-light-svg-icons/faFaceSmile';
import {faClock as falClock} from '@fortawesome/pro-light-svg-icons/faClock';
import {faCommentDots as falCommentDots} from '@fortawesome/pro-light-svg-icons/faCommentDots';
// add the imported icons to the library
library.add(
  falChevronUp,
  falChevronDown,
  falChevronLeft,
  falChevronRight,
  //
  falArrowUpLong,
  falArrowDownLong,
  falArrowLeftLong,
  falArrowRightLong,
  falArrowToBottom,
  falArrowUpRight,
  //
  falArrowUp,
  falArrowDown,
  falArrowLeft,
  falArrowRight,
  //
  falArrowCircleUp,
  falArrowCircleDown,
  falArrowCircleLeft,
  falArrowCircleRight,
  //
  falCheck,
  falTimes,
  falSearch,
  falPhone,
  falEnvelope,
  falAt,
  falCircle,
  falSquare,
  falLocationDot,
  falGlobe,
  falStar,
  falHeart,
  falLink,
  falShare,
  falShareAlt,
  //
  falLanguage,
  falFax,
  falFileDownload,
  falFilePdf,
  falFileWord,
  falFileExcel,
  falSignIn,
  falCalendarAlt,
  falFolder,
  falTape,
  falVirusSlash,
  falFileSlash,
  falGaugeMax,
  falDiagramProject,
  falFaceSmile,
  falClock,
  falCommentDots,
);
// <i class="fal fa-chevron-up"></i>

// Pro Regular
import {faChevronUp} from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import {faChevronDown} from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import {faChevronLeft} from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import {faChevronRight} from '@fortawesome/pro-regular-svg-icons/faChevronRight';
//
import {faArrowUpLong} from '@fortawesome/pro-regular-svg-icons/faArrowUpLong';
import {faArrowDownLong} from '@fortawesome/pro-regular-svg-icons/faArrowDownLong';
import {faArrowLeftLong} from '@fortawesome/pro-regular-svg-icons/faArrowLeftLong';
import {faArrowRightLong} from '@fortawesome/pro-regular-svg-icons/faArrowRightLong';
import {faArrowToBottom} from '@fortawesome/pro-regular-svg-icons/faArrowToBottom';
import {faArrowUpRight} from '@fortawesome/pro-regular-svg-icons/faArrowUpRight';
//
import {faArrowUp} from '@fortawesome/pro-regular-svg-icons/faArrowUp';
import {faArrowDown} from '@fortawesome/pro-regular-svg-icons/faArrowDown';
import {faArrowLeft} from '@fortawesome/pro-regular-svg-icons/faArrowLeft';
import {faArrowRight} from '@fortawesome/pro-regular-svg-icons/faArrowRight';
//
import {faArrowCircleUp} from '@fortawesome/pro-regular-svg-icons/faArrowCircleUp';
import {faArrowCircleDown} from '@fortawesome/pro-regular-svg-icons/faArrowCircleDown';
import {faArrowCircleLeft} from '@fortawesome/pro-regular-svg-icons/faArrowCircleLeft';
import {faArrowCircleRight} from '@fortawesome/pro-regular-svg-icons/faArrowCircleRight';
//
import {faCheck} from '@fortawesome/pro-regular-svg-icons/faCheck';
import {faTimes} from '@fortawesome/pro-regular-svg-icons/faTimes';
import {faSearch} from '@fortawesome/pro-regular-svg-icons/faSearch';
import {faPhone} from '@fortawesome/pro-regular-svg-icons/faPhone';
import {faEnvelope} from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import {faAt} from '@fortawesome/pro-regular-svg-icons/faAt';
import {faCircle} from '@fortawesome/pro-regular-svg-icons/faCircle';
import {faSquare} from '@fortawesome/pro-regular-svg-icons/faSquare';
import {faLocationDot} from '@fortawesome/pro-regular-svg-icons/faLocationDot';
import {faGlobe} from '@fortawesome/pro-regular-svg-icons/faGlobe';
import {faStar} from '@fortawesome/pro-regular-svg-icons/faStar';
import {faHeart} from '@fortawesome/pro-regular-svg-icons/faHeart';
import {faLink} from '@fortawesome/pro-regular-svg-icons/faLink';
import {faShare} from '@fortawesome/pro-regular-svg-icons/faShare';
import {faShareAlt} from '@fortawesome/pro-regular-svg-icons/faShareAlt';
//
import {faLanguage} from '@fortawesome/pro-regular-svg-icons/faLanguage';
import {faFax} from '@fortawesome/pro-regular-svg-icons/faFax';
import {faFileDownload} from '@fortawesome/pro-regular-svg-icons/faFileDownload';
import {faFilePdf} from '@fortawesome/pro-regular-svg-icons/faFilePdf';
import {faFileWord} from '@fortawesome/pro-regular-svg-icons/faFileWord';
import {faFileExcel} from '@fortawesome/pro-regular-svg-icons/faFileExcel';
import {faSignIn} from '@fortawesome/pro-regular-svg-icons/faSignIn';
import {faCalendarAlt} from '@fortawesome/pro-regular-svg-icons/faCalendarAlt';
import {faFolder} from '@fortawesome/pro-regular-svg-icons/faFolder';
import {faTape} from '@fortawesome/pro-regular-svg-icons/faTape';
import {faVirusSlash} from '@fortawesome/pro-regular-svg-icons/faVirusSlash';
import {faFileSlash} from '@fortawesome/pro-regular-svg-icons/faFileSlash';
import {faGaugeMax} from '@fortawesome/pro-regular-svg-icons/faGaugeMax';
import {faDiagramProject} from '@fortawesome/pro-regular-svg-icons/faDiagramProject';
import {faCircleDollar} from '@fortawesome/pro-regular-svg-icons/faCircleDollar';
import {faFaceSmile} from '@fortawesome/pro-regular-svg-icons/faFaceSmile';
import {faClock} from '@fortawesome/pro-regular-svg-icons/faClock';
import {faCommentDots} from '@fortawesome/pro-regular-svg-icons/faCommentDots';
// add the imported icons to the library
library.add(
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  //
  faArrowUpLong,
  faArrowDownLong,
  faArrowLeftLong,
  faArrowRightLong,
  faArrowToBottom,
  faArrowUpRight,
  //
  faArrowUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  //
  faArrowCircleUp,
  faArrowCircleDown,
  faArrowCircleLeft,
  faArrowCircleRight,
  //
  faCheck,
  faTimes,
  faSearch,
  faPhone,
  faEnvelope,
  faAt,
  faCircle,
  faSquare,
  faLocationDot,
  faGlobe,
  faStar,
  faHeart,
  faLink,
  faShare,
  faShareAlt,
  //
  faLanguage,
  faFax,
  faFileDownload,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faSignIn,
  faCalendarAlt,
  faFolder,
  faTape,
  faVirusSlash,
  faFileSlash,
  faGaugeMax,
  faDiagramProject,
  faCircleDollar,
  faFaceSmile,
  faClock,
  faCommentDots,
);
// <i class="far fa-chevron-up"></i>

// Pro Solid
import {faChevronUp as fasChevronUp} from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import {faChevronDown as fasChevronDown} from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import {faChevronLeft as fasChevronLeft} from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import {faChevronRight as fasChevronRight} from '@fortawesome/pro-solid-svg-icons/faChevronRight';
//
import {faArrowUpLong as fasArrowUpLong} from '@fortawesome/pro-solid-svg-icons/faArrowUpLong';
import {faArrowDownLong as fasArrowDownLong} from '@fortawesome/pro-solid-svg-icons/faArrowDownLong';
import {faArrowLeftLong as fasArrowLeftLong} from '@fortawesome/pro-solid-svg-icons/faArrowLeftLong';
import {faArrowRightLong as fasArrowRightLong} from '@fortawesome/pro-solid-svg-icons/faArrowRightLong';
import {faArrowToBottom as fasArrowToBottom} from '@fortawesome/pro-solid-svg-icons/faArrowToBottom';
import {faArrowUpRight as fasArrowUpRight} from '@fortawesome/pro-solid-svg-icons/faArrowUpRight';
//
import {faArrowUp as fasArrowUp} from '@fortawesome/pro-solid-svg-icons/faArrowUp';
import {faArrowDown as fasArrowDown} from '@fortawesome/pro-solid-svg-icons/faArrowDown';
import {faArrowLeft as fasArrowLeft} from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import {faArrowRight as fasArrowRight} from '@fortawesome/pro-solid-svg-icons/faArrowRight';
//
import {faArrowCircleUp as fasArrowCircleUp} from '@fortawesome/pro-solid-svg-icons/faArrowCircleUp';
import {faArrowCircleDown as fasArrowCircleDown} from '@fortawesome/pro-solid-svg-icons/faArrowCircleDown';
import {faArrowCircleLeft as fasArrowCircleLeft} from '@fortawesome/pro-solid-svg-icons/faArrowCircleLeft';
import {faArrowCircleRight as fasArrowCircleRight} from '@fortawesome/pro-solid-svg-icons/faArrowCircleRight';
//
import {faCheck as fasCheck} from '@fortawesome/pro-solid-svg-icons/faCheck';
import {faTimes as fasTimes} from '@fortawesome/pro-solid-svg-icons/faTimes';
import {faSearch as fasSearch} from '@fortawesome/pro-solid-svg-icons/faSearch';
import {faPhone as fasPhone} from '@fortawesome/pro-solid-svg-icons/faPhone';
import {faEnvelope as fasEnvelope} from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import {faAt as fasAt} from '@fortawesome/pro-solid-svg-icons/faAt';
import {faCircle as fasCircle} from '@fortawesome/pro-solid-svg-icons/faCircle';
import {faSquare as fasSquare} from '@fortawesome/pro-solid-svg-icons/faSquare';
import {faLocationDot as fasLocationDot} from '@fortawesome/pro-solid-svg-icons/faLocationDot';
import {faGlobe as fasGlobe} from '@fortawesome/pro-solid-svg-icons/faGlobe';
import {faStar as fasStar} from '@fortawesome/pro-solid-svg-icons/faStar';
import {faHeart as fasHeart} from '@fortawesome/pro-solid-svg-icons/faHeart';
import {faLink as fasLink} from '@fortawesome/pro-solid-svg-icons/faLink';
import {faShare as fasShare} from '@fortawesome/pro-solid-svg-icons/faShare';
import {faShareAlt as fasShareAlt} from '@fortawesome/pro-solid-svg-icons/faShareAlt';
//
import {faFax as fasFax} from '@fortawesome/pro-solid-svg-icons/faFax';
import {faLanguage as fasLanguage} from '@fortawesome/pro-solid-svg-icons/faLanguage';
import {faFileDownload as fasFileDownload} from '@fortawesome/pro-solid-svg-icons/faFileDownload';
import {faFilePdf as fasFilePdf} from '@fortawesome/pro-solid-svg-icons/faFilePdf';
import {faFileWord as fasFileWord} from '@fortawesome/pro-solid-svg-icons/faFileWord';
import {faFileExcel as fasFileExcel} from '@fortawesome/pro-solid-svg-icons/faFileExcel';
import {faSignIn as fasSignIn} from '@fortawesome/pro-solid-svg-icons/faSignIn';
import {faCalendarAlt as fasCalendarAlt} from '@fortawesome/pro-solid-svg-icons/faCalendarAlt';
import {faFolder as fasFolder} from '@fortawesome/pro-solid-svg-icons/faFolder';
import {faTape as fasTape} from '@fortawesome/pro-solid-svg-icons/faTape';
import {faVirusSlash as fasVirusSlash} from '@fortawesome/pro-solid-svg-icons/faVirusSlash';
import {faFileSlash as fasFileSlash} from '@fortawesome/pro-solid-svg-icons/faFileSlash';
import {faGaugeMax as fasGaugeMax} from '@fortawesome/pro-solid-svg-icons/faGaugeMax';
import {faDiagramProject as fasDiagramProject} from '@fortawesome/pro-solid-svg-icons/faDiagramProject';
import {faCircleDollar as fasCircleDollar} from '@fortawesome/pro-solid-svg-icons/faCircleDollar';
import {faFaceSmile as fasFaceSmile} from '@fortawesome/pro-solid-svg-icons/faFaceSmile';
import {faClock as fasClock} from '@fortawesome/pro-solid-svg-icons/faClock';
import {faCommentDots as fasCommentDots} from '@fortawesome/pro-solid-svg-icons/faCommentDots';
// add the imported icons to the library
library.add(
  fasChevronUp,
  fasChevronDown,
  fasChevronLeft,
  fasChevronRight,
  //
  fasArrowUpLong,
  fasArrowDownLong,
  fasArrowLeftLong,
  fasArrowRightLong,
  fasArrowToBottom,
  fasArrowUpRight,
  //
  fasArrowUp,
  fasArrowDown,
  fasArrowLeft,
  fasArrowRight,
  //
  fasArrowCircleUp,
  fasArrowCircleDown,
  fasArrowCircleLeft,
  fasArrowCircleRight,
  //
  fasCheck,
  fasCheck,
  fasTimes,
  fasSearch,
  fasPhone,
  fasEnvelope,
  fasAt,
  fasCircle,
  fasSquare,
  fasLocationDot,
  fasGlobe,
  fasStar,
  fasHeart,
  fasLink,
  fasShare,
  fasShareAlt,
  //
  fasLanguage,
  fasFax,
  fasFileDownload,
  fasFilePdf,
  fasFileWord,
  fasFileExcel,
  fasSignIn,
  fasCalendarAlt,
  fasFolder,
  fasTape,
  fasVirusSlash,
  fasFileSlash,
  fasGaugeMax,
  fasDiagramProject,
  fasCircleDollar,
  fasFaceSmile,
  fasClock,
  fasCommentDots,
);
// <i class="fas fa-chevron-up"></i>

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();
